export default __webpack_public_path__ + "static/media/RabihFirli.3ebc2131.mp3";